'use client';

import dynamic from 'next/dynamic';

const CompetitorLandscape = dynamic(() => import('@/components/pages/CompetitorLandscape'), {
  loading: () => (
    <div className="flex items-center justify-center min-h-[50vh]">
      <div className="text-[var(--color-muted)]">Loading...</div>
    </div>
  ),
  ssr: false,
});

export default function LandscapeClient() {
  return <CompetitorLandscape />;
}
